
export default {
    POST: 'POST',
    PATH: 'PATH',
    QUERY: 'QUERY',
    OTHER: 'OTHER',
    HEADER: 'HEADER'
};
